(ns frontend.view.modals.account-invite.events
  (:require
   [clojure.string :as string]
   [frontend.view.modals.components.processing-modal :as processing-modal]
   [common.email :as email]
   [frontend.state.account :as account]))

(defn form-ready?
  [state]
  (let [{:keys [first-name last-name email]} @state]
    (and (not (string/blank? first-name))
         (not (string/blank? last-name))
         (not (string/blank? email))
         (email/valid-email-pattern? email))))

(defn toggle-set
  [s val]
  (set (if (contains? s val)
         (disj s val)
         (conj s val))))

(defn modify-modules!
  [state kw val]
  (swap! state update kw toggle-set val))

(defn invite-account!
  [state close! on-account-invited]
  (let [{:keys [first-name last-name email role-kw send-email?]} @state]
    (processing-modal/start-processing! state)
    (account/invite-account!
     (fn [resp]
       (processing-modal/success! state)
       (when on-account-invited
         (on-account-invited (:body resp))))
     (fn [err]
       (processing-modal/error! state err))
     {:account     (merge {:account/email (string/trim email)}
                          (when first-name
                            {:account/first-name first-name})
                          (when last-name
                            {:account/last-name last-name}))
      :send-email? send-email?
      :role        role-kw})))

